import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Navigate } from "react-big-calendar";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { GetFontAwesomeIcon } from "@/components/font-awesome-icon";
import UIButton from "@/components/ui-controls/button";
import UIToggleButton from "../ui-controls/toggle-buttons";

const CalendarToolbar = (props) => {
  let {
    localizer: { messages },
    label,
    onView,
    views,
    view,
    onNavigate,
  } = props;
  //   console.log("props", props);
  const toggleOptions = views.map((view) => ({
    label: messages[view],
    value: view,
  }));
  return (
    <Box
      className="d-flex justify-content-space-between"
      sx={{ p: 1, bgcolor: "var(--palette-grid_header)" }}
    >
      <Box
        className="d-flex align-items-center"
        sx={{ gap: "1.25rem", pl: 2, color: "var(--palette-text) !important" }}
      >
        <GetFontAwesomeIcon
          icon={faChevronLeft}
          iconStyles={{ cursor: "pointer" }}
          onClick={() => onNavigate(Navigate.PREVIOUS)}
        />
        <Typography
          sx={{
            whiteSpace: "nowrap",
            flexShrink: 0,
            textAlign: "center",
          }}
          color="custom.sub_heading"
        >
          {label}
        </Typography>
        <GetFontAwesomeIcon
          icon={faChevronRight}
          iconStyles={{ cursor: "pointer" }}
          onClick={() => onNavigate(Navigate.NEXT)}
        />
        <UIButton
          title={"Today"}
          onClick={() => onNavigate(Navigate.TODAY)}
          variant={"outlined"}
          sx={{ padding: "2px 10px" }}
        />
      </Box>
      <Box
        className="d-flex align-items-center view-switch"
        sx={{ gap: "3px" }}
      >
        <UIToggleButton
          selected={view}
          options={toggleOptions}
          handleChange={(e, value) => onView(value)}
          name={"viewOptions"}
          sx={{
            "& .MuiButtonBase-root": {
              minWidth: "37px",
              height: "37px",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default CalendarToolbar;
